// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"LoginForm_loginFormWrapper__j6Zsh","loginFormErrors":"LoginForm_loginFormErrors__Ebd1Q"};